<template>
  <div class="member-award">
    <div class="member-right-inner-bottom">
      <pen-panel
        text="获奖"
        :closAble="true"
        :expandClosSAble="true"
        ref="workingInfo"
      >
        <common-button
          v-if="editFlag"
          size="small"
          type="cancel"
          slot="expand"
          style="margin-left: 5px"
          @click="handleAddClick"
          >新增
        </common-button>
        <!--批量导入按钮-->
        <!-- <common-button
          size="small"
          type="cancel"
          slot="expand"
          @click="queryAll"
          >查询全部</common-button
        > -->
        <common-button
          v-if="this.editFlag"
          size="small"
          type="cancel"
          slot="expand"
          @click="bulkImport"
          style="margin-left: 5px"
          >批量导入</common-button
        >
        <common-button
          v-if="this.editFlag"
          size="small"
          type="cancel"
          slot="expand"
          @click="templateDown('/static/files/Huojiang_FileUpload.xlsx')"
          style="margin-left: 5px"
          >模板下载</common-button
        >

        <!--table表格-->
        <div class="learn-table" style="padding: 20px">
          <member-query-form
            :form="form"
            :params="params"
            :paramsContent="paramsContent"
            @handleAcceptParams="queryData"
          />
          <el-form :model="form" :rules="huojiangRules" ref="ruleForm">
            <el-table
              ref="table"
              v-loading="tableData.isLoading"
              :data="tableData.list"
              max-height="520"
              tooltip-effect="dark"
              highlight-current-row
              size="mini"
              style="width: 100%;"
            >
              <el-table-column
                align="center"
                label="序号"
                width="70"
                prop="index"
                sortable
              >
                <template slot-scope="scope">
                  <div class="index">{{ scope.$index + 1 }}</div>
                </template>
              </el-table-column>

              <el-table-column
                min-width="150"
                label="获奖名称"
                prop="title"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                    prop="title"
                  >
                    <el-input
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      v-model="form.title"
                      clearable
                      placeholder="请输入"
                    >
                    </el-input>
                    <span v-else class="twoLineCls" :title="scope.row.title">{{
                      scope.row.title
                    }}</span>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                min-width="100"
                label="项目等级"
                prop="prjLevelTpCode"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                    prop="prjLevelTpCode"
                  >
                    <el-select
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      v-model="form.prjLevelTpCode"
                      clearable
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in codes.prjLevelCodes"
                        :key="index"
                        :label="item.cdDesc"
                        :value="item.cd"
                      ></el-option>
                    </el-select>
                    <div v-else class="twoLineCls">
                      <span
                        v-for="(item, index) in codes.prjLevelCodes"
                        :key="index"
                        v-if="item.cd == scope.row.prjLevelTpCode"
                        >{{ item.cdDesc }}</span
                      >
                    </div>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                min-width="160"
                label="备注(其他项目等级)"
                prop="prjLevelComment"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                  >
                    <el-input
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      v-model="form.prjLevelComment"
                      clearable
                      placeholder="请输入"
                      :disabled="form.prjLevelTpCode != prjLevelOtherCode"
                    >
                    </el-input>
                    <span
                      v-else
                      class="twoLineCls"
                      :title="scope.row.prjLevelComment"
                      >{{ scope.row.prjLevelComment }}</span
                    >
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                min-width="120"
                label="获奖类别"
                prop="huojiangTpCode"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                    prop="huojiangTpCode"
                  >
                    <el-select
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      v-model="form.huojiangTpCode"
                      clearable
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in codes.huojiangTpCodes"
                        :key="index"
                        :label="item.cdDesc"
                        :value="item.cd"
                      ></el-option>
                    </el-select>
                    <div v-else class="twoLineCls">
                      <span
                        v-for="(item, index) in codes.huojiangTpCodes"
                        :key="index"
                        v-if="item.cd == scope.row.huojiangTpCode"
                        >{{ item.cdDesc }}</span
                      >
                    </div>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                min-width="160"
                label="备注(其他获奖类别)"
                prop="huojiangComment"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                    prop="huojiangComment"
                  >
                    <el-input
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      v-model="form.huojiangComment"
                      clearable
                      placeholder="请输入"
                      :disabled="form.huojiangTpCode != huojiangOtherCode"
                    >
                    </el-input>
                    <span
                      v-else
                      class="twoLineCls"
                      :title="scope.row.huojiangComment"
                      >{{ scope.row.huojiangComment }}</span
                    >
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                min-width="120"
                label="级别"
                prop="levelTpCode"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                    prop="levelTpCode"
                  >
                    <el-select
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      v-model="form.levelTpCode"
                      clearable
                      placeholder="请选择"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in codes.levelTpCodes"
                        :key="index"
                        :label="item.cdDesc"
                        :value="item.cd"
                      ></el-option>
                    </el-select>
                    <div v-else class="twoLineCls">
                      <span
                        v-for="(item, index) in codes.levelTpCodes"
                        :key="index"
                        v-if="item.cd == scope.row.levelTpCode"
                        >{{ item.cdDesc }}</span
                      >
                    </div>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                min-width="160"
                label="备注(其他级别)"
                prop="levelComment"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                  >
                    <el-input
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      v-model="form.levelComment"
                      clearable
                      placeholder="请输入"
                      :disabled="form.levelTpCode != hjLevelOtherCode"
                    >
                    </el-input>
                    <span
                      v-else
                      class="twoLineCls"
                      :title="scope.row.levelComment"
                      >{{ scope.row.levelComment }}</span
                    >
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                label="获得时间"
                min-width="160"
                prop="beginDate"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                    prop="beginDate"
                  >
                    <el-date-picker
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      type="month"
                      v-model="form.beginDate"
                      :picker-options="startPickerOptions"
                      clearable
                      style="width: 100%"
                      placeholder="请选择"
                    >
                    </el-date-picker>
                    <span v-else class="twoLineCls">{{
                      scope.row.beginDate | MonthFormat
                    }}</span>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                label="授予单位"
                min-width="200"
                prop="unitName"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                    prop="unitName"
                  >
                    <el-input
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      v-model="form.unitName"
                      clearable
                      placeholder="请输入"
                    >
                    </el-input>
                    <span
                      v-else
                      class="twoLineCls"
                      :title="scope.row.unitName"
                      >{{ scope.row.unitName }}</span
                    >
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                label="本人排名"
                min-width="150"
                prop="ownRank"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                    prop="ownRank"
                  >
                    <el-input
                      v-if="!scoreEditFlag && scope.$index == globalIndex"
                      v-model="form.ownRank"
                      clearable
                      placeholder="请输入"
                    >
                    </el-input>
                    <span v-else class="twoLineCls">{{
                      scope.row.ownRank
                    }}</span>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                width="120"
                label="评分"
                v-if="!this.editFlag"
                prop="score"
                sortable
              >
                <template slot-scope="scope">
                  <el-form-item
                    :style="{
                      'margin-bottom':
                        scope.$index == globalIndex ? '23px' : '0px'
                    }"
                    prop="score"
                  >
                    <el-input
                      v-if="scope.$index == globalIndex"
                      v-model="form.score"
                      clearable
                      placeholder="请输入"
                    >
                    </el-input>
                    <span v-else class="twoLineCls" :title="scope.row.score">{{
                      scope.row.score
                    }}</span>
                  </el-form-item>
                </template>
              </el-table-column>

              <el-table-column
                align="center"
                label="附件"
                prop=""
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <div style="overflow-x: auto;width: 100%">
                    <span v-if="!scoreEditFlag && scope.$index == globalIndex">
                      <div
                        v-for="(item, index) of form.attachIds"
                        :key="item.id"
                        class="attachment-original-name"
                      >
                        <a
                          @click="preViewAttachment(item, index, scope.$index)"
                          style="cursor: pointer"
                          >{{ item.attachmentOriginalName }}</a
                        >
                        <el-button
                          style="border:0px !important;cursor: pointer;"
                          type="text"
                          size="small"
                          class="el-icon-close"
                          @click="removeAttachment(scope.$index, index)"
                        ></el-button>
                      </div>
                    </span>
                    <span v-else>
                      <div
                        v-for="(item, index) of scope.row.attachIds"
                        :key="item.id"
                        class="attachment-original-name"
                      >
                        <a
                          @click="preViewAttachment(item, index, scope.$index)"
                          style="cursor: pointer"
                          >{{ item.attachmentOriginalName }}</a
                        >
                      </div>
                    </span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                v-if="this.editFlag || this.scoreEditFlag"
                align="center"
                prop=""
                label="操作"
                width="180"
                fixed="right"
              >
                <template slot-scope="scope">
                  <!--上传附件-->
                  <el-button
                    v-if="scope.$index == globalIndex"
                    style="border:0px !important;"
                    type="text"
                    size="small"
                    @click="dialogVisible = true"
                    >上传附件
                  </el-button>
                  <!--编辑-->
                  <el-button
                    style="border:0px !important;"
                    type="text"
                    size="small"
                    v-if="scope.$index != globalIndex"
                    @click="handleEditClick(scope.row, scope.$index)"
                    >编辑</el-button
                  >
                  <!--删除-->
                  <el-button
                    style="border:0px !important;"
                    type="text"
                    size="small"
                    v-if="scope.$index != globalIndex"
                    @click="handleDeleteClick(scope.row, scope.$index)"
                    >删除</el-button
                  >
                  <!--保存-->
                  <el-button
                    style="border:0px !important;"
                    type="text"
                    size="small"
                    v-if="scope.$index == globalIndex"
                    @click="handleSaveClick(scope.row, scope.$index, true)"
                    >保存</el-button
                  >
                  <!--取消-->
                  <el-button
                    style="border:0px !important;"
                    type="text"
                    size="small"
                    v-if="scope.$index == globalIndex"
                    @click="handleCancelClick(scope.row, scope.$index)"
                    >取消</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-form>
        </div>

        <!--批量导入弹窗-->
        <el-dialog
          style="text-align: center"
          title="请导入数据(该操作将刷新页面，请先保存已编辑数据)"
          :visible.sync="drawerVisible"
        >
          <el-upload
            class="upload-demo"
            drag
            action
            :multiple="false"
            :http-request="fileUpload"
            :file-list="showFileList"
            :limit="1"
            accept=".xls,.xlsx"
            :before-upload="beforeUploadImport"
            :on-exceed="handleExceed"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em style="color:#5ed5d9;">点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">仅支持xls/xlsx文件</div>
          </el-upload>

          <el-button
            style="margin-top: 20px"
            type="primary"
            size="small"
            @click="saveHuojiangByFile"
            :loading="fileSaveBtnLoading"
          >
            保存数据
          </el-button>
        </el-dialog>

        <!--批量导入错误数据弹窗-->
        <el-dialog
          style="text-align: center;"
          :title="'批量错误数据提示(共' + errorData.huojiangs.length + '行)'"
          class="error-dialog"
          custom-class="error-dialog"
          :close-on-click-modal="false"
          :visible.sync="errorDataVisible"
          @close="errorDialogClose"
        >
          <div style="height:100%;overflow-y: auto">
            <el-table
              :data="errorData.huojiangs"
              tooltip-effect="dark"
              highlight-current-row
              height="100%"
              size="mini"
              style="width: 100%;"
            >
              <el-table-column
                align="center"
                label="行号"
                width="50"
                prop="lineNo"
              ></el-table-column>
              <el-table-column label="获奖名称" prop="title"></el-table-column>
              <!--          <el-table-column label="项目名称" prop="prjTitle"></el-table-column>-->
              <el-table-column
                label="项目等级"
                prop="prjLevelTpCode"
              ></el-table-column>
              <el-table-column
                label="备注(其他项目等级)"
                prop="prjLevelComment"
              ></el-table-column>
              <el-table-column
                label="类型"
                prop="huojiangTpCode"
              ></el-table-column>
              <el-table-column
                label="备注(其他获奖类别)"
                prop="huojiangComment"
              ></el-table-column>
              <el-table-column
                label="级别"
                prop="levelTpCode"
              ></el-table-column>
              <el-table-column
                label="备注(其他级别)"
                prop="levelComment"
              ></el-table-column>
              <el-table-column
                align="center"
                label="获得时间"
                prop="bDate"
              ></el-table-column>
              <el-table-column
                label="授予单位"
                prop="unitName"
              ></el-table-column>
              <el-table-column
                label="本人排名"
                prop="ownRankString"
              ></el-table-column>
            </el-table>
          </div>
        </el-dialog>
      </pen-panel>
    </div>

    <div class="demo-image__preview">
      <el-image ref="previewImg" :preview-src-list="attachment.attachmentsLink">
      </el-image>
    </div>

    <!--动画加载组件-->
    <animation
      :loadingDataVisible="loadingDataVisible"
      :loadingText="'Loading'"
    ></animation>
    <!-- 附件预览弹窗 -->
    <dialog-preview
      :preViewObj="preViewObj"
      :showPreview="showPreview"
      @handleClosePreview="showPreview = false"
    />
    <!-- 附件搜索 -->
    <historical-attachment
      :dialogVisible.sync="dialogVisible"
      @AddAttachment="AddAttachment"
    />
    <new-data-form
      :form="form"
      :formContent="formContent"
      :rules="huojiangRules"
      :visible.sync="newVisiable"
      @handleConfirmClick="handleNewData"
      @handleCancelClick="handleCancelClick"
    />
  </div>
</template>

<script>
import {
  ATTA_UPLOAD_COMPONENT_TYPE_STR,
  ATTA_FILE_SHOW_TYPE,
  ATTA_FILE_DOWN_TYPE,
  MEMBER_TABLEDATA_LENGTH
} from "@/constants/constants";
import {
  PRJLEVEL_OTHER_CODE,
  HUOJIANG_OTHER_CODE,
  HUOJIANG_LEVEL_OTHER_CODE
} from "@/constants/constants";
import { Message } from "element-ui";
import cookie from "@/utils/cookie";
import http from "@/utils/axios";
import * as constantsRules from "@/constants/constantRules";
import Animation from "../../loading/animation";
import PenPanel from "../../custom/PenPanel";

export default {
  name: "MemberWork",
  components: { PenPanel, Animation },
  data() {
    return {
      children: [
        { path: "/privateplot/member/paper", name: "论文" },
        { path: "/privateplot/member/subject", name: "课题" },
        { path: "/privateplot/member/gcp", name: "GCP" },
        { path: "/privateplot/member/work", name: "著作" },
        { path: "/privateplot/member/patent", name: "专利" },
        { path: "/privateplot/member/award", name: "获奖" },
        { path: "/privateplot/member/standardization", name: "标准化建设" }
      ],
      loadingDataVisible: false, //是否显示加载动画
      drawerVisible: false, //是否显示批量导入弹窗
      errorDataVisible: false,
      showFileList: [], //附件显示的列表
      fileList: [], //附件列表
      fileSaveBtnLoading: false, //保存数据动画
      isDelete: false,
      showPreview: false,
      newVisiable: false,
      dialogVisible: false,
      preViewObj: {},
      params: {},
      form: {
        id: null,
        userId: "",
        title: "",
        prjTitle: "",
        unitName: "",
        huojiangTpCode: "",
        huojiangComment: "",
        prjLevelTpCode: "",
        prjLevelComment: "",
        levelTpCode: "",
        levelComment: "",
        ownRank: null,
        beginDate: "",
        score: null,
        attachIds: []
      },
      tableData: {
        pageNum: 1,
        pageSize: 9999,
        isLoading: false,
        list: []
      },
      codes: {
        huojiangTpCodes: [],
        levelTpCodes: [],
        prjLevelCodes: []
      },
      startPickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "至今",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          }
        ]
      },
      attachmentsMultipart: [], //文件数组
      addAttachIndex: "",
      attachment: {
        attachmentsLink: [],
        //图片的类型后缀
        imagesType: ["jpg", "jpeg", "png", "gif"]
      },
      //附件的允许上传的类型
      acceptAttachmentType: ATTA_UPLOAD_COMPONENT_TYPE_STR,
      acceptAttachmentShowType: ATTA_FILE_SHOW_TYPE,
      acceptAttachmentDownType: ATTA_FILE_DOWN_TYPE,
      huojiangRules: constantsRules.HuojiangRules,
      globalIndex: null, //学历信息的全局索引
      tableDataLength: MEMBER_TABLEDATA_LENGTH, //表格数据显示条数
      errorData: {
        huojiangs: []
      },
      editFlag: null,
      scoreEditFlag: null,
      prjLevelOtherCode: PRJLEVEL_OTHER_CODE,
      huojiangOtherCode: HUOJIANG_OTHER_CODE,
      hjLevelOtherCode: HUOJIANG_LEVEL_OTHER_CODE
    };
  },

  mounted() {
    this.editFlag =
      this.$store.state.MemberManageModule.userId == null &&
      !["view", "update"].includes(this.$store.state.MemberManageModule.type)
        ? true
        : false;
    this.scoreEditFlag =
      this.$store.state.MemberManageModule.userId != null &&
      this.$store.state.MemberManageModule.type == "update"
        ? true
        : false;
    this.getHuojiangCodes();

    window.onbeforeunload = e => {
      if (this.globalIndex == null) {
        return;
      }
      // 通知浏览器不要执行与事件关联的默认动作
      e.preventDefault();
      // Chrome 需要 returnValue 被设置成空字符串
      e.returnValue = "";
    };
    if (window.history && window.history.pushState) {
      history.pushState(null, null, document.URL);
      window.addEventListener("popstate", this.onBack, false);
    }
  },

  methods: {
    getHuojiangCodes() {
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl +
            "/eims-api/code/getCodes/memberHuojiangCode",
          {
            token: token,
            data: {}
          }
        )
        .then(response => {
          if ((response.data.code = "00000")) {
            let codes = response.data.data;
            this.codes.huojiangTpCodes = codes["026"];
            this.codes.levelTpCodes = codes["027"];
            this.codes.prjLevelCodes = codes["058"];
            this.queryData();
          }
        });
    },
    queryData(flag) {
      this.loadingDataVisible = true;
      let token = cookie.getCookie("token");
      http
        .post(
          window.config.api.baseUrl + "/eims-api/personal/data/getHuojiangList",
          {
            token: token,
            data: {
              pageNum: this.tableData.pageNum,
              pageSize: this.tableData.pageSize,
              userId: this.$store.state.MemberManageModule.userId,
              ...this.params
            }
          }
        )
        .then(response => {
          if (response.data.code == "00000") {
            let list = response.data.data.eimsSzyHuojiangs;
            let obj = null;
            if (flag) {
              obj = JSON.parse(
                JSON.stringify(
                  this.tableData.list[this.tableData.list.length - 1]
                )
              );
            }
            this.tableData.list = list;
            if (obj) {
              this.form = JSON.parse(JSON.stringify(obj));
              this.tableData.list.push(obj);
              this.globalIndex = this.tableData.list.length - 1;
            }
          }
        })
        .finally(res => {
          this.loadingDataVisible = false;
        });
    },

    //编辑操作
    handleEditClick(row, index) {
      if (this.globalIndex != null) {
        this.warnDialog(row, index);
      } else {
        this.globalIndex = index;
        this.form = JSON.parse(JSON.stringify(row));
      }
    },

    //删除操作
    handleDeleteClick(row, index) {
      let that = this;
      that
        .$confirm("确定将获奖名称为" + row.title + "的数据删除？", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          if (row.id) {
            this.loadingDataVisible = true;
            let token = cookie.getCookie("token");
            http
              .post(
                window.config.api.baseUrl +
                  "/eims-api/personal/data/deleteHuojiangInfo",
                {
                  token: token,
                  data: {
                    id: row.id
                  }
                }
              )
              .then(response => {
                if (response.data.code == "00000") {
                  Message.success("删除成功");
                  this.isDelete = true;
                  if (index == this.globalIndex) {
                    this.globalIndex = null;
                  } else if (index < this.globalIndex) {
                    if (this.globalIndex != this.tableData.list.length - 1) {
                      this.globalIndex = this.globalIndex - 1;
                    }
                  }
                  this.queryData(
                    this.globalIndex == this.tableData.list.length - 1 ? 1 : 0
                  );
                }
              })
              .finally(() => {
                this.isDelete = false;
                this.loadingDataVisible = false;
              });
          }
        })
        .catch(() => {});
    },

    //保存操作
    handleSaveClick(row, index, flag) {
      if (!this.validateFileForm()) {
        Message.warning("编辑框校验不通过，请检查其内容！");
        return false;
      }
      if (this.scoreEditFlag) {
        this.loadingDataVisible = true;
        http
          .post(
            window.config.api.baseUrl +
              "/eims-api/personal/score/editHuojiangInfo",
            {
              token: cookie.getCookie("token"),
              data: {
                id: row.id,
                score: (this.form.score ? this.form.score : 0) + ""
              }
            }
          )
          .then(response => {
            if ((response.data.code = "00000")) {
              Message.success("修改成功!");
              this.queryData();
              if (flag) {
                this.globalIndex = null;
                Object.assign(this.$data.form, this.$options.data().form);
              } else {
                if (index > this.globalIndex) {
                  this.globalIndex = index;
                } else {
                  this.globalIndex = index + 1;
                }
                this.form = JSON.parse(JSON.stringify(row));
              }
            }
          })
          .finally(() => {
            this.loadingDataVisible = false;
          });
        return;
      }
      Message.info("数据导入可能需要几分钟,请耐心等待");
      let that = this;
      // 使用form表单的数据格式
      const paramsData = new FormData();
      // 将上传文件数组依次添加到参数paramsData中
      this.attachmentsMultipart.forEach((it, index) => {
        paramsData.append(`file`, it.file);
      });
      if (this.attachmentsMultipart.length === 0) {
        paramsData.append(`file`, null);
      }
      let jsonData = {
        token: cookie.getCookie("token"),
        data: {
          attachment: this.form.attachIds,
          eimsHuojiang: {
            id: this.form.id,
            userId: this.form.userId,
            title: this.form.title,
            prjTitle: this.form.prjTitle,
            unitName: this.form.unitName,
            ownRank: this.form.ownRank ? Number(this.form.ownRank) : null,
            huojiangTpCode: this.form.huojiangTpCode,
            huojiangComment: this.form.huojiangComment,
            prjLevelTpCode: this.form.prjLevelTpCode,
            prjLevelComment: this.form.prjLevelComment,
            levelTpCode: this.form.levelTpCode,
            levelComment: this.form.levelComment,
            beginDate: this.form.beginDate
              ? this.moment(this.form.beginDate).format("YYYY-MM")
              : null
          }
        }
      };
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append(
        "data",
        new Blob([JSON.stringify(jsonData)], { type: "application/json" })
      );
      // 表单数据和文件一起上传,调用后端接口
      this.loadingDataVisible = true;
      http
        .post(
          window.config.api.baseUrl +
            "/eims-api/personal/data/editHuojiangInfo",
          paramsData
        )
        .then(response => {
          if (response.data.code === "00000") {
            if (row.id) {
              Message.success("保存成功!");
            } else {
              Message.success("新增成功!");
            }
            this.queryData();
            this.globalIndex = null;
            Object.assign(this.$data.form, this.$options.data().form);
            this.attachmentsMultipart = [];
          }
        })
        .finally(() => {
          this.loadingDataVisible = false;
        });
    },

    //取消操作
    handleCancelClick() {
      this.globalIndex = null;
      this.form = this.$options.data().form;
      this.attachmentsMultipart = [];
    },

    //新增操作
    handleAddClick() {
      if (this.globalIndex !== null) {
        this.warnDialog();
      } else {
        this.newVisiable = true;
      }
    },
    //新增一条数据
    handleNewData(attach) {
      this.attachmentsMultipart = attach;
      this.handleSaveClick(this.form, null, true);
    },

    warnDialog(row, index) {
      const h = this.$createElement;
      this.$confirm("提示", {
        message: h("p", null, [
          h(
            "p",
            { style: "font-size: 18px;line-height: 40px;" },
            "有内容没有保存，是否保存并退出编辑？"
          ),
          h(
            "p",
            { style: "font-size: 14px;color: #00000069;" },
            "放弃修改，更新的内容不会自动保存"
          )
        ]),
        distinguishCancelAndClose: true,
        confirmButtonText: "保存",
        cancelButtonText: "放弃修改",
        type: "warning"
      })
        .then(() => {
          if (!this.validateFileForm()) {
            Message.warning("编辑框校验不通过，请检查其内容！");
            return;
          }
          if (row) {
            this.handleSaveClick(row, index);
          } else {
            this.handleSaveClick(this.form, null, true);
          }
        })
        .catch(action => {
          /* 点击编辑按钮时 */
          if (action !== "cancel") return;
          /* 点击编辑按钮时 */
          this.handleCancelClick();
          if (!row) {
            this.newVisiable = true;
          } else {
            this.globalIndex = index;
            this.form = JSON.parse(JSON.stringify(row));
          }
        });
    },

    //查询全部
    queryAll() {
      this.$router.push({ path: "/privateplot/member/award/list" });
    },

    //关闭弹窗
    handleCloseDialog() {
      this.warnDialog.isShow = false;
    },

    //添加附件
    attachmentUpload(file, fileList, index) {
      this.attachmentsMultipart.push(file);
    },

    //上传之前的判断
    handleBeforeUpload(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      if (!this.acceptAttachmentType.includes(testMsg)) {
        this.$message({
          message: "上传附件类型不合法！",
          type: "warning",
          showClose: true
        });
        return false;
      } else {
        const localUrl = URL.createObjectURL(
          new Blob([file], { type: file.type })
        );
        this.form.attachIds.push({
          attachmentOriginalName: file.name,
          localUrl
        });
      }
    },

    //移除附件
    removeAttachment(listIndex, index) {
      if (!this.form.attachIds[index].id) {
        this.attachmentsMultipart.splice(index, 1);
      }
      this.form.attachIds.splice(index, 1);
    },

    //点击查看按钮
    preViewAttachment(item) {
      this.preViewObj = item;
      if (item.localUrl) {
        this.preViewObj.url = item.localUrl;
      } else {
        this.preViewObj.url =
          window.config.api.baseUrl +
          "/eims-api/attachment/findFile?token=" +
          cookie.getCookie("token") +
          "&code=" +
          item.code;
      }
      this.showPreview = true;
    },
    //准备需要查看的附件的链接,然后显示或者下载附件
    handleView(item) {
      let fileType = item.attachmentOriginalName.substring(
        item.attachmentOriginalName.lastIndexOf(".") + 1
      );
      const elink = document.createElement("a");
      http
        .get(
          window.config.api.baseUrl +
            "/eims-api/attachment/findFile?token=" +
            cookie.getCookie("token") +
            "&code=" +
            item.code,
          { responseType: "blob" }
        )
        .then(response => {
          if (response) {
            let attaFileDownTypeElement = this.acceptAttachmentDownType[
              fileType
            ];
            elink.download = item.attachmentOriginalName.substring(
              0,
              item.attachmentOriginalName.lastIndexOf(".")
            );
            elink.style.display = "none";
            elink.target = "_blank";
            elink.href = URL.createObjectURL(
              new Blob([response.data], { type: attaFileDownTypeElement })
            );
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    //批量导入
    bulkImport() {
      if (!this.fileSaveBtnLoading) {
        this.showFileList = [];
        this.fileList = [];
      }
      this.drawerVisible = true;
    },

    //导入模板下载
    templateDown(fileName) {
      const a = document.createElement("a");
      a.href = fileName;
      a.download = "获奖信息模板.xlsx";
      a.target = "_blank";
      a.click();

      // var pathName=window.document.location.pathname;
      // var projectName=pathName.substring(0,pathName.substr(1).indexOf('/')+1);
      // return 'http://' + window.location.host + projectName + fileName
    },

    fileUpload(file, fileList) {
      //由于组件可能存在问题 ,直接共用一个list会出现选择文件之后文件列表不显示文件名的情况
      //所以需要定义两个,一个用于显示文件名,一个用于接受文件
      this.showFileList = [];
      this.fileList = [];
      let fileInfo = {
        name: file.file.name
      };
      this.fileList.push(file);
      this.showFileList.push(fileInfo);
    },

    // 批量导入之前判断类型
    beforeUploadImport(file) {
      let testMsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      const extension1 = testMsg === "xls";
      const extension2 = testMsg === "xlsx";
      if (!extension1 && !extension2) {
        this.$message({
          message: "上传文件只能是xls或xlsx格式！",
          type: "warning"
        });
        return false;
      } else {
        return true;
      }
    },

    handleExceed(files, fileList) {
      Message.warning({ message: `只允许上传一个文件`, showClose: true });
    },

    saveHuojiangByFile() {
      if (this.showFileList.length === 0) {
        Message.error({ message: "请先选择上传的文件", showClose: true });
        return;
      }
      if (this.showFileList.length !== 1) {
        Message.error({ message: "一次只允许上传一个文件", showClose: true });
        return;
      }
      // 使用form表单的数据格式
      const paramsData = new FormData();
      // 将上传文件数组依次添加到参数paramsData中
      this.fileList.forEach((it, index) => {
        paramsData.append(`file`, it.file);
      });
      let jsonData = {
        token: cookie.getCookie("token")
      };
      // Message.info("数据导入可能需要几分钟,请耐心等待")
      //将表单数据添加到参数paramsData中,需要将参数转化成Blob后端才能识别到文件
      paramsData.append(
        "data",
        new Blob([JSON.stringify(jsonData)], { type: "application/json" })
      );
      // Message.success("数据导入成功");
      // this.drawerVisible = false
      // 表单数据和文件一起上传,调用后端接口
      // this.fileSaveBtnLoading = true
      this.loadingDataVisible = true;
      http
        .post(
          window.config.api.baseUrl +
            "/eims-api/personal/data/uploadHuojiangInfo",
          paramsData
        )
        .then(response => {
          if (response.data.code === "00000") {
            let data = response.data.data;
            Message.success("获奖信息批量导入操作完成");
            this.globalIndex = null;
            Object.assign(this.$data.form, this.$options.data().form);
            this.queryData();
            if (data.total != 0) {
              this.errorData.huojiangs = data.eimsSzyHuojiangs;
              this.errorDataVisible = true;
            }
          }
        })
        .finally(() => {
          this.loadingDataVisible = false;
          this.drawerVisible = false;
        });
    },

    errorDialogClose() {
      Object.assign(this.$data.errorData, this.$options.data().errorData);
    },

    //规则校验
    validateFileForm() {
      let result = false;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          result = true;
        }
      });
      return result;
    },

    // 监听返回按钮的处理函数
    onBack() {
      if (this.globalIndex != null) {
        const h = this.$createElement;
        this.$confirm("提示", {
          message: h("p", null, [
            h(
              "p",
              { style: "font-size: 18px;line-height: 40px;" },
              "有内容没有保存，是否保存并退出编辑？"
            ),
            h(
              "p",
              { style: "font-size: 14px;color: #00000069;" },
              "放弃修改，更新的内容不会自动保存"
            )
          ]),
          distinguishCancelAndClose: true,
          confirmButtonText: "保存",
          cancelButtonText: "放弃修改",
          type: "warning"
        })
          .then(() => {
            if (!this.validateFileForm()) {
              Message.warning("编辑框校验不通过，请检查其内容！");
              return;
            }
            this.handleSaveClick(this.form, this.globalIndex);
          })
          .catch(action => {
            if (action === "cancel") {
              this.globalIndex = null;
              this.$emit("getEditFlag", false);
              this.$router.go(-1);
            } else {
              history.pushState(null, null, document.URL);
            }
          });
      } else {
        this.$router.go(-1);
      }
    },
    AddAttachment(files, attachmentsMultipart) {
      if (attachmentsMultipart)
        this.attachmentsMultipart.push(...attachmentsMultipart);

      files.forEach(item => {
        if (item.uid) {
          item.localUrl = item.url;
        }
        this.form.attachIds.push(item);
      });
    }
  },

  destroyed() {
    window.removeEventListener("popstate", this.onBack, false);
  },

  beforeRouteLeave(to, from, next) {
    if (this.globalIndex == null) {
      next();
      return;
    }
    const h = this.$createElement;
    this.$confirm("提示", {
      message: h("p", null, [
        h(
          "p",
          { style: "font-size: 18px;line-height: 40px;" },
          "有内容没有保存，是否保存并退出编辑？"
        ),
        h(
          "p",
          { style: "font-size: 14px;color: #00000069;" },
          "放弃修改，更新的内容不会自动保存"
        )
      ]),
      distinguishCancelAndClose: true,
      confirmButtonText: "保存",
      cancelButtonText: "放弃修改",
      type: "warning"
    })
      .then(() => {
        if (!this.validateFileForm()) {
          Message.warning("编辑框校验不通过，请检查其内容！");
          return;
        }
        this.handleSaveClick(this.form, this.globalIndex);
        this.globalIndex = null;
        this.$emit("getEditFlag", false);
        let number = this.children.findIndex(
          item => to.fullPath.indexOf(item.path) > -1
        );
        if (number == -1) {
          this.$emit("clickLeftMenu", { path: to.fullPath });
        }
        next();
      })
      .catch(action => {
        if (action === "cancel") {
          this.globalIndex = null;
          this.$emit("getEditFlag", false);
          let number = this.children.findIndex(
            item => to.fullPath.indexOf(item.path) > -1
          );
          if (number == -1) {
            this.$emit("clickLeftMenu", { path: to.fullPath });
          }
          next();
        } else {
          //改变上方菜单
          this.$emit("changeRightMenu", { left: 1, right: 5 });
          next(false);
        }
      });
  },
  computed: {
    formContent() {
      return [
        {
          label: "获奖名称",
          value: "title",
          type: "input"
        },
        {
          label: "项目等级",
          value: "prjLevelTpCode",
          type: "select",
          option: this.codes.prjLevelCodes.map(item => {
            item.label = item.cdDesc;
            item.value = item.cd;
            return item;
          })
        },
        {
          label: "备注(其他项目等级)",
          value: "natureComment",
          type: "input",
          disabled: this.form.prjLevelTpCode !== this.prjLevelOtherCode
        },
        {
          label: "获奖类别",
          value: "huojiangTpCode",
          type: "select",
          option: this.codes.huojiangTpCodes.map(item => {
            item.label = item.cdDesc;
            item.value = item.cd;
            return item;
          })
        },
        {
          label: "备注(其他获奖类别)",
          value: "huojiangComment",
          type: "input",
          disabled: this.form.huojiangTpCode !== this.huojiangOtherCode
        },
        {
          label: "级别",
          value: "levelTpCode",
          type: "select",
          option: this.codes.levelTpCodes.map(item => {
            item.label = item.cdDesc;
            item.value = item.cd;
            return item;
          })
        },
        {
          label: "备注(其他级别)",
          value: "levelComment",
          type: "input",
          disabled: this.form.levelTpCode !== this.hjLevelOtherCode
        },
        {
          label: "获得时间",
          value: "beginDate",
          type: "date",
          picker: this.startPickerOptions
        },
        {
          label: "授予单位",
          value: "unitName",
          type: "input"
        },
        {
          label: "本人排名",
          value: "ownRank",
          type: "input"
        },
        {
          label: "评分",
          value: "score",
          type: "input"
        }
      ];
    },

    paramsContent() {
      return [
        {
          label: "获奖名称",
          value: "title",
          type: "input"
        },
        {
          label: "项目等级",
          value: "prjLevelTpCode",
          type: "select",
          option: this.codes.prjLevelCodes.map(item => {
            item.label = item.cdDesc;
            item.value = item.cd;
            return item;
          })
        },
        {
          label: "备注(其他项目等级)",
          value: "prjLevelComment",
          type: "input"
        },
        {
          label: "获奖类别",
          value: "huojiangTpCode",
          type: "select",
          option: this.codes.huojiangTpCodes.map(item => {
            item.label = item.cdDesc;
            item.value = item.cd;
            return item;
          })
        },
        {
          label: "备注(其他获奖类别)",
          value: "huojiangComment",
          type: "input"
        },
        {
          label: "级别",
          value: "levelTpCode",
          type: "select",
          option: this.codes.levelTpCodes.map(item => {
            item.label = item.cdDesc;
            item.value = item.cd;
            return item;
          })
        },
        {
          label: "备注(其他级别)",
          value: "levelComment",
          type: "input"
        },
        {
          label: "获得时间",
          value: "dateRange",
          type: "monthrange"
        },
        {
          label: "授予单位",
          value: "unitName",
          type: "input"
        },
        {
          label: "本人排名",
          value: "ownRank",
          type: "number"
        }
      ];
    }
  },
  watch: {
    globalIndex(newVal) {
      if (this.isDelete) return;
      this.$refs["ruleForm"].resetFields();
      if (newVal == null) {
        this.$emit("getEditFlag", false);
      } else {
        this.$emit("getEditFlag", true);
      }
    },

    "form.prjLevelTpCode"(newVal) {
      if (newVal != this.prjLevelOtherCode) {
        this.form.prjLevelComment = "";
      }
    },

    "form.huojiangTpCode"(newVal) {
      if (newVal != this.huojiangOtherCode) {
        this.form.huojiangComment = "";
      }
    },

    "form.levelTpCode"(newVal) {
      if (newVal != this.hjLevelOtherCode) {
        this.form.levelComment = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.member-award {
  /*如果位置出现了错位的问题,可以加上clear:both;解决*/
  .member-right-inner-bottom {
    clear: both;
    .attachment-original-name:hover {
      color: #2866e3;
      text-decoration: underline;
    }
    .twoLineCls {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .index {
      line-height: 40px;
      position: relative;
      font-size: 14px;
    }
  }
}

/deep/ .el-table .el-table__cell {
  vertical-align: top;
}

/deep/.el-form-item__content {
  line-height: 23px;
}

/deep/ .el-table .cell {
  white-space: unset;
}

/deep/ .el-message-box__status.el-icon-warning  {
  margin-top: -10px;
}

/deep/ .error-dialog .el-dialog__body {
  /*padding: 3px 30px;*/
  overflow-y: auto;
  height: calc(100vh - 15vh - 150px);
}
/deep/ .el-dialog.error-dialog {
  width: 70%;
}

/deep/ .el-image__error {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/memberData/memberAchievements/MemberAward.vue